module.exports = __webpack_public_path__ + "img/start.479aa7e4.jpg";